import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { Container } from "react-bootstrap";

import { ROUTE_PAYMENT } from "../../../../routes";

import { cartApi, myInvoiceApi } from "../../../../utility/api/apiList";

import { showDangerAlert } from "../../../../redux/actions/alert/alertActions";
import cartType from "../../../../redux/actions/cart/cartType";

import useAxios from "../../../../hooks/useAxios";
import scrollToTop from "../../../../libs/scrollToTop";
import {
  educationGender,
  onlinePaymentStatus,
} from "../../../../libs/getConstants";

import LoadingComponent from "../../../../components/public/loading";
import GoBackButtonComponent from "../../../../components/public/goBackButton";
import UserFinancialCompanyDetailComponent from "../../../../components/private/user/userFinancialComponents/userFinancialCompanyDetailComponent";
import UserFinancialPersonalDetailComponent from "../../../../components/private/user/userFinancialComponents/userFinancialPersonalDetailComponent";

export default function UserFinancialDetailContainer() {
  const [statusFinalArray, setStatusFinalArray] = useState([]);
  const [constantsList, setConstantsList] = useState([]);
  const [constantsGenderList, setConstantsGenderList] = useState([]);

  const [checkboxArray, setCheckboxArray] = useState([]);

  let { id } = useParams();

  const history = useHistory();
  const constantsDetail = useSelector((state) => state.constantsDetail);

  const onlineStatusPayment = onlinePaymentStatus();
  const educationGenders = educationGender();

  const dispatch = useDispatch();

  const {
    data: financialData,
    isLoading,
    isLoaded,
    error,
    run,
  } = useAxios({
    url: `${myInvoiceApi}${id}/`,
    showError: true,
    errorMessage: "متاسفانه مشکلی پیش آمده.",
  });

  const { run: runPostCart, isLoading: postCardIsLoading } = useAxios({
    url: cartApi,
    method: "post",
  });

  useEffect(() => {
    document.title = "جزئیات خرید ";
    scrollToTop();
    run().then();
  }, []);

  useEffect(() => {
    if (constantsDetail.constants.length !== 0) {
      setConstantsList(constantsDetail.constants.other);
      var status = [];
      for (
        let index = 1;
        index <= Object.keys(onlineStatusPayment).length;
        index++
      ) {
        var statusArrayItem = onlineStatusPayment[index];
        status.push({
          id: index,
          name: statusArrayItem,
        });
      }
      setStatusFinalArray(status);

      var countGender = Object.keys(educationGenders).length;
      var genderArray = [];
      for (var i = 0, empGender; i < countGender; i++) {
        empGender = educationGenders[i];

        genderArray.push({ id: i, name: empGender });
      }
      setConstantsGenderList(genderArray);
    }
  }, [constantsDetail.constants]);

  const handleChangeCheckboxUpgrade = (e) => {
    var listedCheck = checkboxArray;
    if (e.target.checked) {
      listedCheck.push({ id: e.target.id, name: e.target.name });
    } else {
      listedCheck = listedCheck.filter((item) => item.id != e.target.id);
    }
    setCheckboxArray(listedCheck);
  };

  const handleUpgradeCompanyPurchase = (e) => {
    e.preventDefault();
    if (checkboxArray.length === 0) {
      dispatch(showDangerAlert("لطفا یک خرید را انتخاب کنید."));
      return;
    }
    const data = [];
    for (let index = 0; index < checkboxArray.length; index++) {
      data.push({
        grade: null,
        count: checkboxArray[index].name,
        unitoftime: null,
        salespackage: null,
        upgrade: checkboxArray[index].id,
      });
    }

    const mainData = {
      data: data,
    };

    const genderFinded = constantsGenderList.find(
      (Gitem) => Gitem.id == financialData.education.gender
    );
    const cityFinded = constantsList.city.find(
      (Citem) => Citem.id == financialData.education.city
    );

    const company = {
      id: financialData.education.id,
      name: financialData.education.name,
      city: cityFinded.shahr,
      gender: genderFinded.name,
    };

    dispatch({ type: cartType.SET_COMPANY_DETAILS, payload: company });

    runPostCart(mainData)
      .then(() => {
        history.push({
          pathname: ROUTE_PAYMENT,
        });
      })
      .catch((error) => {
        dispatch(showDangerAlert(error.response.data.details));
      });
  };

  return (
    <section className="p-3">
      {isLoading || !isLoaded ? (
        <LoadingComponent />
      ) : (
        <Container>
          <GoBackButtonComponent className="d-none d-md-block" />
          {!financialData?.education ? (
            <UserFinancialPersonalDetailComponent
              financialData={financialData}
              runPostCart={runPostCart}
              postCardIsLoading={postCardIsLoading}
            />
          ) : (
            <UserFinancialCompanyDetailComponent
              financialData={financialData}
              handleChangeCheckboxUpgrade={handleChangeCheckboxUpgrade}
              handleUpgradeCompanyPurchase={handleUpgradeCompanyPurchase}
            />
          )}
        </Container>
      )}
    </section>
  );
}
